import { useIntl } from "react-intl";

import testIds from "constants/testIds";

import { ReactComponent as UploadIcon } from "assets/images/iconsV2/upload-cloud-02.svg";
import FilePreview from "components/v2/FilePreview/FilePreview";
import { AttachmentBucket } from "types/Common";

import { useOtherAttachments } from "@RequestFormV2/sections/Provider/hooks/useOtherAttachments";
import FileUploadTrigger from "@RequestFormV2/sections/Provider/components/UploadFreightDocumentsSection/FileUploadTrigger";
import FreightDocumentRow from "@RequestFormV2/sections/Provider/components/UploadFreightDocumentsSection/FreightDocumentRow";

interface OtherFilesRowProps {
  otherBucket?: AttachmentBucket;
}

export default function OtherFilesRow({ otherBucket }: OtherFilesRowProps) {
  const intl = useIntl();
  const { files, handleFilesSelect, handleRemove } = useOtherAttachments(otherBucket);

  const uploadLabel = intl.formatMessage({
    id: "request-form.provider.uploadFreightDocuments.uploadFile",
    defaultMessage: "Upload file",
  });

  const otherFilesLabel = intl.formatMessage({
    id: "request-form.provider.uploadFreightDocuments.otherFiles",
    defaultMessage: "Other files",
  });

  return (
    <FreightDocumentRow label={otherFilesLabel}>
      <div className="upload-freight-docs__content">
        {files.length > 0 && (
          <div className="upload-freight-docs__file-previews">
            {files.map((file, index) => (
              <FilePreview
                key={`${file.id}-${index}`}
                fileName={file.filename ?? file.name}
                url={file.url}
                isLoading={(file.progress > 0 && !file.error) || !!file.isDeleting}
                isError={file.error}
                errorMessage={file.errorMessage}
                onClose={file.isDeleting ? undefined : () => handleRemove(file)}
              />
            ))}
          </div>
        )}

        <FileUploadTrigger
          label={uploadLabel}
          iconLeft={<UploadIcon />}
          multiple
          testId={testIds.REQUEST_FORM_PROVIDER_ADD_ATTACHMENTS}
          onChange={handleFilesSelect}
        />
      </div>
    </FreightDocumentRow>
  );
}
